/* Simple appearence with animation AN-1*/
function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}
function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}
/* Simple appearence with animation AN-1*/

function tabHeight() {
  let tab = document.querySelector(
    ".template-collection section.tab-content.section .tab"
  );
  let height;

  if (tab) {
    height = tab.clientHeight - 1;
    document.documentElement.style.setProperty("--tab-height", height + "px");
  } else {
    document.documentElement.style.setProperty("--tab-height", 0 + "px");
  }
}

function whatsappPopup() {
  let btn = document.getElementById('whatsapp-popup-trigger');
  let modal = document.getElementById('whatsappByLocation');

  if(!modal) return;

  let close = modal.querySelector('.close-btn');

  [close,btn].forEach(listen => {
    listen.addEventListener('click', function(){
      modal.classList.toggle('show');
    });
  })
}

document.addEventListener("DOMContentLoaded", function () {
  tabHeight();
  whatsappPopup();
});
